import React from "react";
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Legend,
} from "recharts";

import { Tooltip } from "react-tooltip";

import INDIA_MAP from "../maps/india.json";

import {
  ComposableMap,
  Geographies,
  Geography,
} from "react-simple-maps";

import { FaUsers, FaShoppingCart, FaHeart, FaRupeeSign } from "react-icons/fa";


export default function Dashboard() {


        const stats = {
        users: 12500,
        orders: 3200,
        followers: 8900,
        revenue: 1250000,
      };

        // ===== STATS =====
      const statsData = [
        {
          title: "Total Users",
          value: stats.users,
          icon: <FaUsers />,
          gradient: "linear-gradient(135deg, #ea66d4, #e42e2e)",
        },
        {
          title: "Total Orders",
          value: stats.orders,
          icon: <FaShoppingCart />,
          gradient: "linear-gradient(135deg, #43cea2, #185a9d)",
        },
        {
          title: "Followers",
          value: stats.followers,
          icon: <FaHeart />,
          gradient: "linear-gradient(135deg, #ff758c, #ff7eb3)",
        },
        {
          title: "Revenue (₹)",
          value: stats.revenue,
          icon: <FaRupeeSign />,
          gradient: "linear-gradient(135deg, #f7971e, #ffd200)",
        },
      ];

  // ===== FORMAT =====
  const formatNumber = (num) =>
    new Intl.NumberFormat("en-IN").format(num);

  // ===== CHART DATA =====
  const data = [
    { name: "Jan", users: 400, revenue: 2400 },
    { name: "Feb", users: 700, revenue: 3400 },
    { name: "Mar", users: 1000, revenue: 5000 },
    { name: "Apr", users: 1200, revenue: 7000 },
    { name: "May", users: 1800, revenue: 9000 },
    { name: "Jun", users: 800, revenue: 10000 },
    { name: "Jul", users: 1200, revenue: 9500 },
    { name: "Aug", users: 750, revenue: 9800 },
  ];

  // ===== PIE DATA =====
  const pieData = [
    { name: "Users", value: 400 },
    { name: "Orders", value: 300 },
    { name: "Revenue", value: 300 },
  ];

  const pieData1 = [
    { name: "East", value: 250 },
    { name: "West", value: 150 },
    { name: "South", value: 380 },
    { name: "North", value: 220 },
  ];

  const COLORS = ["#0f22ce", "#0ba517", "#c01111", "#FFBB28" ];

  // ===== MAP DATA =====
  const countryData = {
    IND: 1200,
    USA: 800,
    GBR: 400,
    AUS: 300,
    CAN: 500,
  };

  const stateData = {
    Maharashtra: 1500,
    Karnataka: 900,
    Gujarat: 700,
    Delhi: 600,
    "Tamil Nadu": 800,
    Rajasthan: 400,
    "Uttar Pradesh": 1100,
  };

  const getColor = (value) => {
    if (value > 1200) return "#59da77";
    if (value > 800) return "#ddbe62";
    if (value > 0) return "#d65a66";
    return "#f8f4f4";
  };

  
  return (
    <div className="container mt-5 pt-5">

      <h2 className="text-center mb-4">
        Welcome to Bytlas Intelligence{" "}
        <span className="text-primary fw-bold">
          World Of Digital Solutions!
        </span>
      </h2>

          {/* ===== PREMIUM STATS ===== */}
          <div className="row mb-4">
            {statsData.map((item, i) => (
              <div className="col-md-3 mb-3" key={i}>
                <div
                  className="card text-white shadow-lg border-0 p-3"
                  style={{
                    background: item.gradient,
                    borderRadius: "15px",
                    transition: "0.3s",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                  onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <h6 style={{ opacity: 0.9 }}>{item.title}</h6>
                      <h3 className="fw-bold">{formatNumber(item.value)}</h3>
                    </div>

                    <div
                      style={{
                        fontSize: "28px",
                        background: "rgba(255,255,255,0.2)",
                        padding: "10px",
                        borderRadius: "50%",
                      }}
                    >
                      {item.icon}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

      {/* ===== CHARTS ===== */}
      <div className="row">

        {/* Line Chart */}
        <div className="col-md-6">
          <div className="card shadow p-3">
            <h5>User Growth</h5>
            <ResponsiveContainer width="100%" height={300}>
              <LineChart data={data}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <RechartsTooltip />
                <Line type="monotone" dataKey="users" stroke="#7c0476" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Bar Chart */}
        <div className="col-md-6">
          <div className="card shadow p-3">
            <h5>Revenue Growth</h5>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={data}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <RechartsTooltip />
                <Bar dataKey="revenue" fill="#2b17dd" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Pie Chart */}
        <div className="col-md-6 mt-4">
          <div className="card shadow p-3">
            <center>
            <h5>Business Distribution</h5>
            </center>
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie data={pieData} dataKey="value" outerRadius={100} label>
                  {pieData.map((entry, index) => (
                    <Cell key={index} fill={COLORS[index]} />
                  ))}
                </Pie>
                <Legend />
                <RechartsTooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Pie Chart */}
        <div className="col-md-6 mt-4">
          <div className="card shadow p-3">
            <h5>Orders Distribution</h5>
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie data={pieData1}dataKey="value" outerRadius={100} label>
                  {pieData1.map((entry, index) => (
                    <Cell key={index} fill={COLORS[index]} />
                  ))}
                </Pie>
                <Legend />
                <RechartsTooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* INDIA MAP */}
        <div className="col-md-12 mt-4">
          <div className="card shadow p-3">
            <center>
            <h5>India Users Distribution</h5>
            </center>
                <ComposableMap
                  projection="geoMercator"
                  projectionConfig={{ scale: 900, center: [82, 22] }}
                  style={{ width: "100%", height: "100%" }}
                >
                  <Geographies geography={INDIA_MAP}>
                    {({ geographies }) =>
                      geographies.map((geo) => {
                        const stateName = geo.properties.NAME_1;
                        const value = stateData[stateName];

                        return (
                          <Geography
                            key={geo.rsmKey}
                            geography={geo}
                            fill={getColor(value)}
                            stroke="#999"
                            strokeWidth={0.5}
                            data-tooltip-id="map-tooltip"
                            data-tooltip-content={`${stateName}: ${value || 0} users`}
                          />
                        );
                      })
                    }
                  </Geographies>
                </ComposableMap>

          </div>
        </div>

        {/* WORLD MAP */}
        <div className="col-md-12 mt-4">
          <div className="card shadow p-3">
            <center>
            <h5>Global Users Map</h5>
            </center>
            <ComposableMap>
              <Geographies geography="https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json">
                {({ geographies }) =>
                  geographies.map((geo) => {
                    const code = geo.properties.ISO_A3;
                    const value = countryData[code];
                    return (
                      <Geography
                        key={geo.rsmKey}
                        geography={geo}
                        fill={getColor(value)}
                        stroke="#889cf3"
                        data-tooltip-id="map-tooltip"
                        data-tooltip-content={`${geo.properties.NAME}: ${value || 0} users`}
                      />
                    );
                  })
                }
              </Geographies>
            </ComposableMap>

          </div>
        </div>




      </div>
      {/* TOOLTIP */}
      <Tooltip id="map-tooltip" />

    </div>
  );
}